import PropTypes from 'prop-types';
import {
  breakpointsShape, configPartialShape, dataLayerShape, globalSettingsShape, layoutDataShape,
} from 'Helpers/props-shapes';

const configShape = {
  config: PropTypes.shape({
    ...configPartialShape,
    ...globalSettingsShape,
    ...breakpointsShape,
  }).isRequired,
};

export const galleryPropsShape = {
  ...configShape,
  ...dataLayerShape,
  ...layoutDataShape,
};
